import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.scss";
import Form, { InputField, NewSelectField } from "@components/form";
import { sinkOptions, sinkOptionsIp21 } from "../constant";
import { _selectoptionType } from "@components/form/select-field";
import { DataSourceHandler } from "@api/data-source-handler";
import { useSelector } from "react-redux";
import { RootState } from "@store/types";
import { Text } from "@components/ui/Text";
import { Flex } from "@components/ui/Flex";
import classNames from "classnames";
import { Checkbox, Radio } from "antd";
import type { RadioChangeEvent } from 'antd/lib/radio';
import { ShowWhenTrue } from "@helpers/showwhentrue";
import { storageTypeOptions } from "../constant";

interface HierarchyFormProps {
    activeStep: number;
    setActiveStep: (step: number) => void;
    initialValues: any;
    formSchema: any;
    handleOnSubmit: (values: any) => void;
    isRDBMSview?: boolean;
    isAspenIp21View?: boolean;
}

const HierarchySinkForm: React.FC<HierarchyFormProps> = ({
    activeStep,
    setActiveStep,
    initialValues,
    formSchema,
    handleOnSubmit,
    isRDBMSview = false,
    isAspenIp21View = false
}) => {
    const [allSinkNameOptions, setallSinkNameOptions] = useState<_selectoptionType[]>([]);
    const [sinkNameOptions, setSinkNameOptions] = useState<_selectoptionType[]>([]);
    const [connectionOptions, setConnectionOptions] = useState<_selectoptionType[]>([]);
    const [tableOptions, setTableOptions] = useState<_selectoptionType[]>([]);
    const [fsType, setFsType] = useState<string>('dbfs');
    const [fsTypeResponse, setFsTypeResponse] = useState<any>(null);
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
    const handleConnections = (type: string) => {
        if (type.toLowerCase() === 'snowflake') {
            DataSourceHandler.GetConnectionType(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, type, (res) => {
                const _options = res.map((item: any) => ({
                    label: item.name || item.connectionName,
                    value: item.name || item.connectionName
                }));
                setConnectionOptions(_options);
            });
        } else {
            setConnectionOptions([]);
        }
    };

    const getSinkNames = (type: string) => {
        DataSourceHandler.GetSinkNodes(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, (res) => {
            const allSinkNames = res
                .map((_res: any) => ({
                    label: _res.sinkName,
                    value: _res.sinkName,
                    type: _res.sinkKind
                }));
            setallSinkNameOptions(allSinkNames);
            const filteredSinkNames = allSinkNames
                .filter((_res: any) => _res.type === type)
            setSinkNameOptions(filteredSinkNames);
        });
    };

    const getTableNames = (type: string) => {
        DataSourceHandler.GetTableName(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, type, (res) => {
            const allTableNames = res
                .map((_res: any) => ({
                    label: _res.label,
                    value: _res.label,
                }));
            setTableOptions(allTableNames);
        });
    };

    const getFsType = (type: string) => {
        DataSourceHandler.GetFsType(`${Env?.REACT_APP_PLATFORM_URL}/databrowser/api`, type, (res) => {
            if (!res || !Array.isArray(res)) {
                setFsTypeResponse([]);
                return;
            }
            const allFstype = res.map((_res: any) => ({
                label: _res.name || _res.label || String(_res),
                value: _res.name || _res.value || String(_res),
            }));
            setFsTypeResponse(allFstype);
        });
    };

    useEffect(() => {
        getTableNames(initialValues?.landingConnectionName)
        getSinkNames(initialValues?.sinkKind || "S3");
        if (initialValues?.databaseType === 'Snowflake') {
            handleConnections('snowflake');
        }
    }, [initialValues])

    useEffect(() => {
        if (initialValues?.fsType) {
            setFsType(initialValues.fsType);
            if (initialValues.fsType !== 'dbfs') {
                getFsType(initialValues.fsType);
            }
        }
    }, [initialValues?.fsType])

    return (
        <>
            <Form
                initialValues={initialValues}
                onSubmit={handleOnSubmit}
                validationSchema={formSchema}
                enableReinitialize
            >
                {({ _formikprops: { values, setFieldValue } }) => (
                    <>
                        <div className={styles.jsonHierarchyForm}>
                            <div style={{ padding: 16 }}>
                                <ShowWhenTrue show={!isRDBMSview && !isAspenIp21View}>
                                    <Text fontSize={14} className="mb-1">Staging</Text>
                                </ShowWhenTrue>
                                <NewSelectField
                                    name="sinkKind"
                                    label="Type"
                                    options={isRDBMSview || isAspenIp21View ? sinkOptionsIp21 : sinkOptions}
                                    onOptionClick={(option) => {
                                        setFieldValue("sinkKind", option.value);
                                        const filteredSinkNames = allSinkNameOptions
                                            .filter((_res: any) => _res.type === option.value);
                                        setSinkNameOptions(filteredSinkNames);
                                    }}
                                    required={true}
                                    className={styles["requestName__field"]}
                                />
                                <NewSelectField
                                    name="sinkName"
                                    label="Name"
                                    options={sinkNameOptions}
                                    required={true}
                                    className={styles["requestName__field"]}
                                />
                                {/* <ShowWhenTrue show={!(isRDBMSview)}> */}
                                    <Flex alignItems={"center"} gap="10px" className={classNames(styles["checkbox-tag"], styles["requestName__field"])}>
                                        <Text fontSize={14}>Landing</Text>
                                        <Checkbox
                                            name="landEngenabled"
                                            onChange={(e) => setFieldValue("landingEnabled", e.target.checked)}
                                            checked={values.landingEnabled}
                                        />
                                    </Flex>
                                {/* </ShowWhenTrue> */}
                                <ShowWhenTrue show={values?.landingEnabled}>
                                    <NewSelectField
                                        name="databaseType"
                                        label="Type"
                                        options={[{ label: "Databricks", value: "Databricks" }, { label: "Snowflake", value: "Snowflake" }]}
                                        onOptionClick={(option) => {
                                            setFieldValue("databaseType", option.value);
                                            if (option.value === 'Snowflake') {
                                                handleConnections('snowflake');
                                            } else {
                                                setConnectionOptions([]);
                                            }
                                        }}
                                        className={styles["requestName__field"]}
                                    />
                                    <ShowWhenTrue show={values?.databaseType === 'Snowflake'}>
                                        <NewSelectField
                                            name="landingConnectionName"
                                            label="Select a Connection"
                                            options={connectionOptions}
                                            initial_value={initialValues.landingConnectionName}
                                            onOptionClick={(option) => {
                                                setFieldValue("landingConnectionName", option.value);
                                                if (option.value) {
                                                    getTableNames(option.value);
                                                }
                                            }}
                                            validate={(value: string) => {
                                                if (!value) {
                                                    return "Please select a connection";
                                                }
                                            }}
                                            className={styles["requestName__field"]}
                                            required
                                        />
                                    </ShowWhenTrue>
                                    <ShowWhenTrue show={values?.databaseType === 'Databricks'}>
                                        <InputField
                                            name="tableName"
                                            label="Table Name"
                                            validate={(value: string) => {
                                                if (!value) {
                                                    return "Table name is required";
                                                }
                                                const regex = /^[A-Za-z0-9_.]+$/;
                                                if (!regex.test(value)) {
                                                    return "Table name must not contain spaces or special characters (only letters, numbers, underscore, and dots are allowed).";
                                                }
                                                return undefined;
                                            }}
                                            autoComplete="off"
                                            className={styles["requestName__field"]}
                                            required
                                        />
                                    </ShowWhenTrue>
                                    <ShowWhenTrue show={values?.databaseType === 'Snowflake'}>
                                        <div className={styles["requestName__field"]}>
                                            <Text fontSize={14} className="mb-1">Write to a New Table</Text>
                                            <Radio.Group
                                                name="createNewTable"
                                                value={values.createNewTable ?? false}
                                                onChange={(e: RadioChangeEvent) => {
                                                    setFieldValue("createNewTable", e.target.value);
                                                }}
                                            >
                                                <Radio value={true}>Yes</Radio>
                                                <Radio value={false}>No</Radio>
                                            </Radio.Group>
                                        </div>

                                        <ShowWhenTrue show={values.createNewTable === true}>
                                            <InputField
                                                key="new-table-input"
                                                name="tableName"
                                                label="Table Name"
                                                validate={(value: string) => {
                                                    if (!value) {
                                                        return "Table name is required";
                                                    }
                                                    const regex = /^[A-Za-z0-9_.]+$/;
                                                    if (!regex.test(value)) {
                                                        return "Table name must not contain spaces or special characters (only letters, numbers and underscore are allowed).";
                                                    }
                                                    return undefined;
                                                }}
                                                autoComplete="off"
                                                className={styles["requestName__field"]}
                                                required
                                            />
                                        </ShowWhenTrue>
                                        <ShowWhenTrue show={values.createNewTable === false}>
                                            <NewSelectField
                                                key="existing-table-select"
                                                name="tableName"
                                                label="Select Table"
                                                options={tableOptions}
                                                initial_value={initialValues.tableName}
                                                onOptionClick={(option) => setFieldValue("tableName", option.value)}
                                                className={styles["requestName__field"]}
                                                required
                                                validate={(value: string) => {
                                                    if (!value) {
                                                        return "Please select a table";
                                                    }
                                                    return undefined;
                                                }}
                                            />
                                        </ShowWhenTrue>

                                        <NewSelectField
                                            name="mode"
                                            label="Mode"
                                            options={[{ label: "Append", value: "Append" }, { label: "OverWrite", value: "Overwrite" }]}
                                            initial_value={initialValues.mode}
                                            onOptionClick={(option) => { setFieldValue("mode", option.value); }}
                                            className={styles["requestName__field"]}
                                        />

                                        <InputField
                                            name="schema"
                                            label="Schema"
                                            autoComplete="off"
                                            validate={(value: string) => {
                                                const regex = /^[A-Za-z0-9_]+$/;
                                                if (!regex.test(value)) {
                                                    return "This field is required.";
                                                }
                                                return undefined;
                                            }}
                                            className={styles["requestName__field"]}
                                            required
                                        />
                                        <InputField
                                            name="warehouse"
                                            label="Warehouse"
                                            autoComplete="off"
                                            className={styles["requestName__field"]}
                                        />
                                        <InputField
                                            name="userRole"
                                            label="User Role"
                                            autoComplete="off"
                                            className={styles["requestName__field"]}
                                        />

                                        <NewSelectField
                                            name="fsType"
                                            label="Type"
                                            options={storageTypeOptions}
                                            onOptionClick={(option) => {
                                                getFsType(option.value);
                                                setFieldValue("fsType", option.value);
                                                setFsType(option.value);
                                            }}
                                            className={styles["requestName__field"]}
                                        />

                                        <InputField
                                            name="externalStagingLocation"
                                            label="External Transfer Location"
                                            autoComplete="off"
                                            className={styles["requestName__field"]}
                                        />
                                        <ShowWhenTrue show={fsType !== 'dbfs'}>
                                            <NewSelectField
                                                name="connectionNameForExternalStaging"
                                                label="Select a Connection for External Staging Location"
                                                options={fsTypeResponse || []}
                                                initial_value={initialValues.connectionNameForExternalStaging}
                                                onOptionClick={(option) => {
                                                    setFieldValue("connectionNameForExternalStaging", option.value);
                                                }}
                                                validate={(value: string) => {
                                                    if (!value) {
                                                        return 'Please select a connection';
                                                    }
                                                    return undefined;
                                                }}
                                                className={styles["requestName__field"]}
                                                required
                                            />
                                        </ShowWhenTrue>
                                    </ShowWhenTrue>
                                </ShowWhenTrue>
                            </div>
                        </div>
                        <div className={styles.hierarchyFormFooter}>
                            <button type="button" className="btn btn-grey btn-md" onClick={() => { setActiveStep(activeStep - 1); }}>
                                Back
                            </button>
                            <button type="submit" className="btn btn-yellow btn-md" >
                                Next
                            </button>
                        </div>
                    </>
                )}
            </Form>
        </>
    );
};

export default HierarchySinkForm;
